import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

import { surfaceVariants, type SurfaceVariants } from './surface-variants.js';

export interface SurfaceProps
  extends HTMLAttributes<HTMLDivElement>,
    SurfaceVariants {}

export function Surface({ className, ...props }: SurfaceProps) {
  return <div {...props} className={cn(surfaceVariants(), className)} />;
}
